<template>
  <Draggable v-if="isVue2" v-model="targetValue" :class="classWrapper">
    <template v-for="element of targetValue">
      <slot :id="element.id" name="item" :element="element" />
    </template>
  </Draggable>

  <div v-else :class="classWrapper">
    <Draggable v-model="targetValue" item-key="id">
      <template #item="{ element }">
        <slot :id="element.id" name="item" :element="element" />
      </template>
    </Draggable>
  </div>
</template>

<script lang="ts">
import Draggable from 'vuedraggable'
import type { ComponentPropsOptions, PropType } from 'vue-demi'
import { computed, defineComponent, isVue2 } from 'vue-demi'
import type { FileData } from '@svoi-ui/interfaces/file-picker'

const modelProp: ComponentPropsOptions = isVue2
  ? {
      value: {
        type: Array as PropType<Array<File | FileData>>,
        default: [] as Array<File | FileData>
      }
    }
  : {
      modelValue: {
        type: Array as PropType<Array<File | FileData>>,
        default: [] as Array<File | FileData>
      }
    }

export default defineComponent({
  components: {
    Draggable
  },
  props: {
    ...modelProp,
    classWrapper: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'on-delete-file', 'update:modelValue'],

  setup(props, { emit }) {
    const targetValue = computed({
      // @ts-expect-error
      get: () => (isVue2 ? props.value : props.modelValue),
      set: v => {
        emit(isVue2 ? 'input' : 'update:modelValue', v)
      }
    })

    return { targetValue, isVue2 }
  }
})
</script>
